// Analytics scaffold (Fase 4): GA4 + PostHog with graceful fallback.
// If env vars are empty → logs to console only.

const GA_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID;
const PH_KEY = process.env.REACT_APP_POSTHOG_KEY;
const PH_HOST = process.env.REACT_APP_POSTHOG_HOST || "https://app.posthog.com";

let initialized = false;
let posthogRef = null;

export function initAnalytics() {
  if (initialized) return;
  initialized = true;

  if (!GA_ID && !PH_KEY) {
    // eslint-disable-next-line no-console
    console.info("[analytics] disabled — no REACT_APP_GA4_MEASUREMENT_ID or REACT_APP_POSTHOG_KEY set");
    return;
  }

  if (GA_ID) {
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(GA_ID)}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    window.gtag("config", GA_ID, { send_page_view: false });
    // eslint-disable-next-line no-console
    console.info(`[analytics] GA4 initialized · ${GA_ID}`);
  }

  if (PH_KEY) {
    // Load PostHog dynamically so it does not fail the build when the package is not installed.
    // Set REACT_APP_POSTHOG_KEY and install `posthog-js` at deploy time to activate.
    const modName = "posthog-js";
    import(/* webpackIgnore: true */ modName).then((m) => {
      const posthog = m.default || m;
      posthog.init(PH_KEY, { api_host: PH_HOST, capture_pageview: false });
      posthogRef = posthog;
      // eslint-disable-next-line no-console
      console.info("[analytics] PostHog initialized");
    }).catch(() => {
      // eslint-disable-next-line no-console
      console.info("[analytics] posthog-js not available (install to activate)");
    });
  }
}

function log(event, props) {
  // eslint-disable-next-line no-console
  console.debug(`[analytics] ${event}`, props || {});
}

export function track(event, props = {}) {
  log(event, props);
  if (GA_ID && window.gtag) window.gtag("event", event, props);
  if (posthogRef) { try { posthogRef.capture(event, props); } catch (_) {} }
}

export function identify(userId, traits = {}) {
  log("identify", { userId, traits });
  if (GA_ID && window.gtag) window.gtag("set", "user_properties", traits);
  if (posthogRef) { try { posthogRef.identify(userId, traits); } catch (_) {} }
}

export function pageView(path) {
  log("page_view", { path });
  if (GA_ID && window.gtag) window.gtag("event", "page_view", { page_path: path });
  if (posthogRef) { try { posthogRef.capture("$pageview", { $current_url: window.location.href }); } catch (_) {} }
}

export function reset() {
  if (posthogRef) { try { posthogRef.reset(); } catch (_) {} }
}
